var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.articlesParProduit(_vm.articles), function(article, iArticle) {
      return _c(
        "div",
        {
          key: "article" + iArticle,
          style: _vm.verrouille ? "opacity:.7" : "",
          attrs: { id: "accordion" + iArticle }
        },
        [
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-header flex-center-space-between" },
              [
                _c("span", [
                  !_vm.mercurialesChargees
                    ? _c("i", { staticClass: "fas fa-spinner fa-spin mr-2" })
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.nomArticle(article.nom)))
                ]),
                _c("div", { staticClass: "flex-end" }, [
                  _c(
                    "span",
                    {
                      class: [
                        "pl-3 pr-3 pt-1 pb-1",
                        {
                          meilleurPrixProduitAgap:
                            _vm.totalPcbMinimal(article.produits) ==
                            _vm.mieuxDisantGeneral
                        }
                      ],
                      attrs: { "v-tooltip": "Mieux-disant" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("afficherPrix")(
                            _vm.totalPcbMinimal(article.produits)
                          )
                        )
                      )
                    ]
                  ),
                  _vm.articleOrigine
                    ? _c("div", { staticClass: "flex-center-space-between" }, [
                        _c("span", { staticClass: "ml-5" }, [
                          _c("i", {
                            staticClass: "fa-star cursor-pointer",
                            class: [
                              {
                                "fas text-warning": _vm.articleGlobalEnFavori(
                                  article.produitId
                                )
                              },
                              {
                                far: !_vm.articleGlobalEnFavori(
                                  article.produitId
                                )
                              },
                              { "fa-spin": _vm.isLoading(article) }
                            ],
                            on: {
                              click: function($event) {
                                return _vm.setArticleFavori(article)
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _c("div", { staticClass: "card-container" }, [
              _c("div", { staticClass: "card card-minimal" }, [
                _vm._m(0, true),
                _c("hr", { staticClass: "mt-0 mb-0" }),
                _c("div", { staticClass: "table-body" }, [
                  _c(
                    "table",
                    {
                      staticClass: "table table-sm table-borderless text-center"
                    },
                    [
                      _vm._m(1, true),
                      _c(
                        "tbody",
                        _vm._l(article.produits, function(
                          ligneArticle,
                          iLigne
                        ) {
                          return _c(
                            "tr",
                            {
                              key: "article" + iLigne,
                              class: [
                                { "ligne-desactivee": ligneArticle.bloque },
                                {
                                  "ligne-origine-selectionnee": _vm.estArticleOrigine(
                                    article,
                                    ligneArticle
                                  )
                                },
                                {
                                  "ligne-selectionnee": _vm.articleEstSelectionne(
                                    article,
                                    ligneArticle
                                  )
                                }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.selectionnerLigne(
                                    article,
                                    ligneArticle
                                  )
                                }
                              }
                            },
                            [
                              _c("td", { staticClass: "aligner-gauche" }, [
                                _vm._v(
                                  _vm._s(ligneArticle.designation) +
                                    " - " +
                                    _vm._s(ligneArticle.marque)
                                )
                              ]),
                              _c(
                                "td",
                                [
                                  ligneArticle.urlFT
                                    ? _c("BoutonFicheTechnique", {
                                        attrs: {
                                          size: "sm",
                                          fournisseurId:
                                            ligneArticle.fournisseurId,
                                          reference: ligneArticle.reference,
                                          urlFT: ligneArticle.urlFT
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("td", [
                                _vm._v(_vm._s(ligneArticle.reference))
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fournisseurNom(
                                      ligneArticle.fournisseurId
                                    )
                                  )
                                )
                              ]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(ligneArticle.pcb) +
                                    " " +
                                    _vm._s(
                                      _vm.abregerTexte(ligneArticle.uc, 10)
                                    )
                                )
                              ]),
                              _c("td", [
                                _c(
                                  "span",
                                  {
                                    class: [
                                      "pl-2 pr-2 pt-1 pb-1",
                                      {
                                        meilleurPrixArticleFournisseur:
                                          _vm.prixMinimal(article.produits) ==
                                          ligneArticle.prixUnitaire
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("afficherPrix")(
                                            ligneArticle.prixUnitaire
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]),
                              _c("td", [
                                _c(
                                  "span",
                                  {
                                    class: [
                                      "pl-2 pr-2 pt-1 pb-1",
                                      {
                                        meilleurPrixArticleFournisseur:
                                          _vm.totalPcbMinimal(
                                            article.produits
                                          ) ==
                                          _vm.totalPcb(
                                            (_vm.articleOrigine &&
                                              _vm.articleOrigine
                                                .quantiteBesoinEnUC) ||
                                              0,
                                            ligneArticle.pcb,
                                            ligneArticle.prixUnitaire
                                          )
                                      }
                                    ]
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("afficherPrix")(
                                            _vm.totalPcb(
                                              (_vm.articleOrigine &&
                                                _vm.articleOrigine
                                                  .quantiteBesoinEnUC) ||
                                                0,
                                              ligneArticle.pcb,
                                              ligneArticle.prixUnitaire
                                            )
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]),
                              _c("td", [
                                _c("i", {
                                  staticClass: "fa-star",
                                  class: [
                                    {
                                      "fas text-warning": _vm.articleEnFavori(
                                        article.produitId,
                                        ligneArticle.fournisseurId
                                      )
                                    },
                                    {
                                      far: !_vm.articleEnFavori(
                                        article.produitId,
                                        ligneArticle.fournisseurId
                                      )
                                    },
                                    {
                                      "fa-spin": _vm.isLoading(
                                        article,
                                        ligneArticle
                                      )
                                    }
                                  ],
                                  on: {
                                    click: function($event) {
                                      return _vm.setArticleFavori(
                                        article,
                                        ligneArticle
                                      )
                                    }
                                  }
                                })
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      { staticClass: "table table-sm table-borderless text-center" },
      [
        _c("colgroup", [
          _c("col"),
          _c("col", { attrs: { width: "30" } }),
          _c("col", { attrs: { width: "75" } }),
          _c("col", { attrs: { width: "160" } }),
          _c("col", { attrs: { width: "100" } }),
          _c("col", { attrs: { width: "90" } }),
          _c("col", { attrs: { width: "90" } }),
          _c("col", { attrs: { width: "40" } })
        ]),
        _c("thead", [
          _c("th", { staticClass: "aligner-gauche" }, [_vm._v("Désignation")]),
          _c("th", [_vm._v("FT")]),
          _c("th", [_vm._v("Réf.")]),
          _c("th", [_vm._v("Fournisseur")]),
          _c("th", [_vm._v("PCB")]),
          _c("th", [_vm._v("PU HT")]),
          _c("th", [_vm._v("Total HT")]),
          _c("th")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { attrs: { width: "30" } }),
      _c("col", { attrs: { width: "75" } }),
      _c("col", { attrs: { width: "160" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "90" } }),
      _c("col", { attrs: { width: "90" } }),
      _c("col", { attrs: { width: "40" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }